export default {
      id: "municipalite-usage",
      viewBox: "0 0 29 44",
      url: "../dist/images/" + "sprite.svg#municipalite-usage",
      toString: function () {
        return this.url;
      }
    }